module.exports = __webpack_public_path__ + "6371023f0c1394b74d880d2c0bf6f27d.svg";